// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3637":"5d8a59bb2654b7f1","3722":"ad87bf14f0eb718a","6511":"28c07a7901e1aa47","9606":"5fe0a162a8155b13"}[chunkId] + ".css";
};